import { takeEvery, select, put } from 'redux-saga/effects'
import { initialize } from 'redux-form/immutable'

import { postReviewsUserReviewers } from '../actions'
import { getHelperRequestElement } from '../selectors'
import { List, Map } from 'immutable'
import { ReviewersUser } from 'store/records/reviews'
import { ADD_REVIEWERS_FORM } from 'app/constants/reviews'

export function* handlePostReviewsUserReviewersSuccess() {
  // needs to reinitialize values here because redux-form created in modal from immutable state
  const requestElement = yield select(getHelperRequestElement)
  const newInitialData = Map({
    reviewers: List(
      requestElement.getIn(['data', 'reviewers']).map(reviewer => {
        reviewer.isMemberNotSavedYet = false
        return new ReviewersUser(reviewer)
      })
    ),
  })
  yield put(initialize(ADD_REVIEWERS_FORM, newInitialData))
}

export default function* postReviewsUserReviewersSuccessSaga() {
  yield takeEvery(postReviewsUserReviewers.success.toString(), handlePostReviewsUserReviewersSuccess)
}
